import React from 'react';
import './header.style.css'
const Header = () => {
  return (<div id='header'>
    <ul>
    <li>R</li>
    <li>O</li>
    <li>C</li>
    <li>K</li>
    <li></li>
    <li>P</li>
    <li>A</li>
    <li>P</li>
    <li>E</li>
    <li>R</li>
    <li></li>
    <li>S</li>
    <li>C</li>
    <li>I</li>
    <li>S</li>
    <li>S</li>
    <li>O</li>
    <li>R</li>
    <li>S</li>
  </ul>
  
  </div>)
}

export default Header;